import React, { useState, useRef, useEffect } from 'react'
import { AnimatePresence } from 'framer-motion';
import { motion } from 'framer-motion';
import Classes from './MainLayout.module.css';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { authActions } from '../../../redux-store';

const sampleProfile = '/assets/images/user.png';

export default function ProfileDropDown() {
    const companyInfo = useSelector((state) => state.companyInfo?.info);
    const { user } = useSelector((state) => state.auth);
    
    const dispatch = useDispatch();

    const [dropDown, setdropDown] = useState(false);
    const dropdownRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setdropDown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const navigateTo = useNavigate();

    const handleNavigate = (page) => {
        setdropDown(false);
        navigateTo(page);
    }

    const handleLogout = async () => {
        localStorage.clear();
        sessionStorage.clear();
        await dispatch(authActions.logout());
    };


    return (
        <div
            className={Classes.dropDown}
            ref={dropdownRef}
        >
            {/* Dropdown Head */}
            <div className={`flexAlign10 pointer mr10`}
                onClick={() => setdropDown(!dropDown)}
            >
                <div className={Classes.card_img} >
                    <img src={user?.imageURL ? user?.imageURL : sampleProfile} className={Classes.card_inner_img} />
                </div>
            </div>

            {/* Dropdown Body */}
            <AnimatePresence>
                {dropDown && (
                    <motion.div
                        initial={{ opacity: 0, y: -5 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -5 }}
                        transition={{
                            duration: 0.15,
                        }}
                        className={Classes.dropDownBody}
                        style={{ top: '42px', right: '0' }}
                    >
                        <div className={Classes.dropDownBodyInner}>
                            <div className={Classes.profileHeader} >
                                <div className={Classes.card_img2} >
                                    <img src={user?.imageURL ? user?.imageURL : sampleProfile} className={Classes.card_inner_img} />
                                </div>
                                <div className={Classes.headerTxt} >
                                    <h4> John Doe </h4>
                                    <h5> Agency admin </h5>
                                </div>
                            </div>
                            <div className={Classes.dropDownLine}></div>
                            <div
                                className={`${Classes.dropDownElem}`}
                                onClick={() => { handleNavigate('/profile-settings') }}
                            >
                                <h5>Profile & account</h5>
                            </div>
                            <div
                                className={`${Classes.dropDownElem}`}
                                onClick={() => { handleNavigate('/change-password') }}
                            >
                                <h5>Change Password</h5>
                            </div>
                            {/* <div
                                className={`${Classes.dropDownElem}`}
                                onClick={() => { handleNavigate('/other-settings') }}
                            >
                                <h5>Settings</h5>
                            </div> */}
                            <div className={Classes.dropDownLine}></div>
                            <div
                                className={`${Classes.dropDownElem}`}
                                onClick={handleLogout}
                            >
                                <h5>Sign out</h5>
                            </div>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
            {/* Hidden input for accessibility */}
            <input
                type="hidden"
                aria-label="Without label"
                readOnly
            />
        </div>
    )
}
